import { Model } from 'modules/core/lib/mobx-rest'

export interface ICopyScheduleStats {
  shifts_count: number
  rest_days_count: number
  employees_count: number
}

class CopyScheduleStats extends Model<ICopyScheduleStats> {
  static urlRoot() {
    return '/shift_management/copy_schedule_stats'
  }
}

export default CopyScheduleStats
